import {APIEvents} from "../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "./base/ClientInterface";

export function scrubPackage(data, dispatcher, errorAction) {
    let startTime = Date.now();
    getNPSWClient().scrubPackage(data)
        .then(({success, data}) => {
            if (success) {
                dispatcher(data);
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.ScrubPackage, startTime);
            } else {
                errorAction("internal_error");
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.ScrubPackage, startTime, true);
            }
        });
}